var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-box table home-container",style:({height:_vm.height+'px'})},[_c('div',{staticStyle:{"font-size":"40px"}},[_vm._v("404~！")])])
}
var staticRenderFns = []

export { render, staticRenderFns }